module.exports = __webpack_public_path__ + "img/banner1@2x.4503d1ec.png";